import logo from './logo.svg';
import './App.css';
import Freelance from "./pages/Freelance"

function App() {
  return (
    <div className="App">
      <Freelance />
    </div>
  );
}

export default App;
